import {
  PublicMarketplaceConfig,
  UpsertPublicMarketplacePayload,
} from '@/@types/PublicMarketplace'
import { isAxiosError } from 'axios'
import { api } from './api'

const emptyPublicMarketplaceConfig = (): PublicMarketplaceConfig => ({
  status: 'disabled',
  enabled: false,
  offer_id: null,
  checkout_id: null,
  category: null,
  description: null,
  level: null,
  language: null,
  certificate: null,
  advantages: [],
  modules: [],
  producer: {
    biography: null,
    instagram_url: null,
    facebook_url: null,
    youtube_url: null,
    photo_url: null,
  },
  rejection_reason: null,
  submitted_at: null,
  reviewed_at: null,
})

async function getPublicMarketplace(
  productId: string,
): Promise<{ data: PublicMarketplaceConfig }> {
  try {
    const response = await api.get(`/v1/products/${productId}/public-marketplace`)
    return response.data
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === 404) {
      return { data: emptyPublicMarketplaceConfig() }
    }
    throw error
  }
}

async function upsertPublicMarketplace(
  productId: string,
  data: UpsertPublicMarketplacePayload,
): Promise<{ data: PublicMarketplaceConfig }> {
  const response = await api.put(
    `/v1/products/${productId}/public-marketplace`,
    data,
  )
  return response.data
}

export const PublicMarketplaceService = {
  getPublicMarketplace,
  upsertPublicMarketplace,
}
